import { apiClient } from "../../../base/ApiClient";

export const submitCarePlanReview = async (payload) => {
  const response = await apiClient.post("/careplan/api/care-plan-reviews/", payload);
  return response.data;
};

export const getCarePlanReviewsByClient = async (clientID, carePlanID = null, paginate = false, page = 1, pageSize = 10) => {
  const params = {
    client: clientID,
    paginate: paginate ? "true" : "false",
    page: page + 1,
    page_size: pageSize
  };

  if (carePlanID) params.care_plan = carePlanID;

  const response = await apiClient.get("/careplan/api/care-plan-reviews/", { params });
  return response.data;
};

export const getCarePlanReviews = async (params = { paginate: "false" }) => {
  const response = await apiClient.get("/careplan/api/care-plan-reviews/", { params });
  return response.data;
};

export const getCarePlanReviewById = async (id) => {
  const response = await apiClient.get(`/careplan/api/care-plan-reviews/${id}/`);
  return response.data;
};

export const createCarePlanReview = async (data) => {
  const response = await apiClient.post("/careplan/api/care-plan-reviews/", data);
  return response.data;
};

export const updateCarePlanReview = async (id, data) => {
  const response = await apiClient.patch(`/careplan/api/care-plan-reviews/${id}/`, data);
  return response.data;
};

export const deleteCarePlanReview = async (id) => {
  const response = await apiClient.delete(`/careplan/api/care-plan-reviews/${id}/`);
  return response.data;
};